import { render, staticRenderFns } from "./_shop_deny_general_modal.vue?vue&type=template&id=361d0524&scoped=true&"
import script from "./_shop_deny_general_modal.vue?vue&type=script&lang=js&"
export * from "./_shop_deny_general_modal.vue?vue&type=script&lang=js&"
import style0 from "./_shop_deny_general_modal.vue?vue&type=style&index=0&id=361d0524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361d0524",
  null
  
)

export default component.exports